import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    await http.post(`/v1/item-pricing/set-quote-list`, payload)
    return true
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/auto-set-associated/index.js